<!-- Don't touch dividers that contains ids, cause they are used in unit test -->
<div class="container">
  Textarea
  <ui-mention id="mention-txa" [uiSuggestions]="suggestions" (uiOnSelect)="onSelect($event)">
    <textarea rows="2" placeholder="type here" uiMentionTrigger ui-input [(ngModel)]="inputValue" (ngModelChange)="onChange($event)"></textarea>
  </ui-mention>

  Input
  <ui-mention [uiSuggestions]="suggestions" (uiOnSelect)="onSelect($event)">
    <input placeholder="input here" uiMentionTrigger ui-input [(ngModel)]="inputValue" (ngModelChange)="onChange($event)" />
  </ui-mention>

  With icons
  <ui-mention [uiSuggestions]="webFrameworks" [uiValueWith]="valueWith" (uiOnSelect)="onSelect($event)">
    <input ui-input uiMentionTrigger [(ngModel)]="inputFramework" />
    <ng-container *uiMentionSuggestion="let framework">
      <ui-avatar [uiPicture]="framework.icon" uiSize="sm"></ui-avatar>
      <span>{{ framework.name }} - {{ framework.type }}</span>
    </ng-container>
  </ui-mention>
</div>
